const ApiNavs ={
    'body':'',
    'start': function(){
        let self = this;
        self.init();
        self.setNavs();


    },
    'setNavs': function(){
       let self = this;
       let navTriggers = self.body.find('[nav-trigger]');
        navTriggers.unbind('click');
        navTriggers.each(function(){
           let navTrigger = $(this);
           navTrigger.on('click', function(){
                let thisClick = $(this);
               let navTriggerValue = navTrigger.attr('nav-trigger');
               let navName = self.body.find('[nav-name="'+navTriggerValue+'"]');
               navName.removeClass('hidden');

               self.setNavClose(navName);
            });
       });
    },
    'setNavClose': function(navName){
        let self = this;
        let navs = self.body.find('.nav');
        let navCloses = navName.find('[nav-close]');
        navCloses.unbind('click');
        navCloses.on('click', function(){
            let thisClick = $(this);
            navs.addClass('hidden');
        });
    },
    'init':function(){
        let self = this;
        self.body = $('body');
    }
}

$(document).ready(function(){
    ApiNavs.start();
});
